module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "ch01"
    }
  }, [_c('a', {
    attrs: {
      "id": "page25"
    }
  }, [_c('div', {
    staticClass: "chapterHead"
  }, [_c('h2', {
    staticClass: "chapterNumber",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Part 1")])]), _vm._v(" "), _c('h2', {
    staticClass: "chapterTitle1",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Spacebird")])])])]), _c('div', {
    staticClass: "chapterBody"
  }, [_c('a', {
    attrs: {
      "id": "page25"
    }
  }, [_c('p', {
    staticClass: "chapterOpenerText",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("The Monitor Corps scoutship "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Torrance")]), _vm._v(" was engaged on a mission which was both highly important and deadly dull. Like the other units of its flotilla it had been assigned a relatively tiny volume of space in Sector Nine—one of the many three-dimensional blanks which still appeared in the Federation’s charts—to fill in the types and positions of the stars which it contained and the numbers of planets circling them.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Because a ten-man scoutship did not have the facilities for handling a first contact situation, they were forbidden to land or even make a close approach to these planets. They would identify the technologically advanced worlds, if any, by analyzing the radio frequency and other forms of radiation emanating from them. As Major Madden, the vessel’s captain, had told them at the start of the mission, they were simply going to count lights in the sky and that was all.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Naturally, Fate could not resist a temptation like "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("that…")])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Radar, sir,” said a voice from the controlroom speaker. “We have a blip on the close-approach screen. Distance six miles, closing slowly, non-collision course.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Lock on the telescope,” said the Captain, “and let’s see it.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Yes, sir. Repeater screen Two.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("On Corps scoutships discipline was strict only when circumstances warranted it, and normally those circumstances did not arise during a mapping mission. As a result the noises coming from the speaker resembled a debate rather than a series of station reports.")])]), _c('a', {
    attrs: {
      "id": "page26"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“It looks like a…a bird, sir, with its wings spread.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“A plucked bird.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Has anyone calculated the chances against materializing this close to an object in interstellar space?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I think it’s an asteroid, or molten material which congealed by accident into that shape.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Two lights years from the nearest sun?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Quiet, please,” said the Captain. “Lock on an analyzer and report.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("There was a short pause, then: “Estimated size, roughly one-third that of this ship. It’s non-reflective, non-metallic, non-mineral and—”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You’re doing a fine job of telling me what it isn’t,” said the Captain dryly.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“It is organic, sir, and…”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Yes?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“And alive.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("For a few seconds the controlroom speaker and the Captain held their breath, then Madden said firmly, “Power Room, maneuvering thrust in five minutes. Astrogation, match courses and close to five hundred yards. Ordnance, stand by. Surgeon-Lieutenant Brenner will prepare for EVA.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The debate was over.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("During the ensuing four hours Lieutenant Brenner examined the creature, initially at a safe distance and later as closely as his suit would allow. He was sure that the analyzer had been a little too optimistic over what was most likely a not quite frigid corpse. Certainly the thing was no threat because it could not move even if it had wanted to. The covering of what looked like large, flat barnacles and the rock-hard cement which held them together saw to that.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Later, when he was ending his report to the Captain, he said, “To sum up, sir, it is suffering from a pretty weird skin condition which got out of control and caused it to be dumped—certainly it didn’t fly out here. This implies a race with space-travel who are subject to a disease which scares them so badly that they dump the sufferers into space while they are still alive.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page26"
    }
  }, [_vm._v("“As you know,” he continued, “I don’t have the qualifications to treat e-t diseases, and the being is too large to fit into our hold. ")]), _c('a', {
    attrs: {
      "id": "page27"
    }
  }, [_vm._v("But we could enlarge our hyperspace envelope and tow it to Sector General.")])]), _c('a', {
    attrs: {
      "id": "page27"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“That would make a nice break in the mapping routine,” he added hopefully, “and I’ve never been to that place. I’m told that not all the nurses there have six legs.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The Captain was silent for a moment, then he nodded.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I have,” he said. “Some of them have more.”")]), _vm._v(" "), _c('p', {
    staticClass: "paraCenter1",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "Images/ast.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("Framed in the rescue tender’s aft vision screen the tremendous structure that was Sector Twelve General Hospital hung in space like a gigantic cylindrical Christmas tree. Its thousands of viewports were constantly ablaze with light in the dazzling variety of color and intensity necessary for the visual equipment of its patients and staff, while inside its three hundred and eighty-four levels was reproduced the environments of all the intelligent life-forms known to the Galactic Federation—a biological spectrum ranging from the ultra-frigid methane-breathers through the more normal oxygen- and chlorine-breathing types up to the exotic beings who existed by the direct conversion of hard radiation.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("In addition to the patients, whose numbers and physiological classifications were a constant variable, there was a medical and maintenance staff comprising sixty-odd differing life-forms with sixty different sets of mannerisms, body odors and ways of looking at life.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The staff of Sector General prided themselves that no case was too big, too small or too hopeless, and their reputation and facilities were second to none. They were an extremely able, dedicated, but not always serious bunch, and Senior Physician Conway could not rid himself of the idea that on this occasion someone was playing a complicated joke on him.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Now that I see it,” he said dryly, “I still can’t believe it.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Pathologist Murchison, who occupied the position beside him, stared at the image of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Torrance")]), _vm._v(" and its tow without comment. On the controlroom ceiling, where it clung with six fragile, sucker-tipped legs, Doctor Prilicla trembled slightly and said, “It could prove to be an interesting and exciting professional challenge, friend Conway.”")])]), _c('a', {
    attrs: {
      "id": "page28"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The musical trills and clicks of the Cinrusskin’s speech were received by Conway’s translator pack, relayed to the translation computer at the center of the hospital and transmitted back to his earpiece as flat, emotionless English. As expected, the reply was pleasant, polite and extremely non-controversial.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Prilicla was insectile, exe-skeletal, six-legged and with a pair of iridescent and not quite atrophied wings and possessing a highly-developed empathic faculty. Only on Cinruss with its one-eighth gravity and dense atmosphere could a race of insects have grown to such dimensions and in time developed intelligence and an advanced civilization. But in Sector General Prilicla was in deadly danger for most of its working day. It had to wear gravity nullifiers everywhere outside its own quarters because the gravity pull which most of its colleagues considered normal would instantly have crushed it flat, and when Prilicla held a conversation with anyone it kept well out of reach of any thoughtless movement of an arm or tentacle which could easily cave in its fragile body or snap off a leg.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Not that anyone would have wanted to hurt Prilicla—it was too well-liked for that. The Cinrusskin’s empathic faculty forced it to be kind and considerate to "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("everyone")]), _vm._v(" in order to make the emotional radiation of the people around it as pleasant for itself as possible.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Except when its professional duty exposed it to pain and violent emotion in a patient, and that situation might arise within the next few minutes.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Turning suddenly to Prilicla, Conway said, “Wear your lightweight suit but stay well clear of the being until we tell you that there is no danger of movement, involuntary or otherwise, from it. We shall wear heavy duty suits, mostly because they have more hooks on which to hang our diagnostic equipment, and I shall ask "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Torrance")]), _vm._v("’s medic to do the same.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Half an hour later Lieutenant Brenner, Murchison and Conway were hanging beside the form of the enormous bird while Prilicla, wearing a transparent plastic bubble through which projected its bony mandibles, drifted beside the lock of their tender.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“No detectable emotional radiation, friend Conway,” reported the empath.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I’m not surprised,” said Murchison.")])]), _c('a', {
    attrs: {
      "id": "page29"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“It could be dead,” said the Lieutenant defensively. “But when we found it the body temperature was measurably above the norm for an object warmed only by a two light-years distant sun.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“There was no criticism intended, Doctor,” said Murchison soothingly. “I was simply agreeing with our empathic friend. But did you, before or during the trip here, carry out any examinations, observations or tests on this patient, or reach any tentative conclusions as a result of such tests? And don’t be shy, Lieutenant—we may be the acknowledged experts in xenological medicine and physiology here, but we got that way by listening and looking, not by gratuitous displays of our expertise. You were curious, naturally, and…?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Yes, ma’am,” said Brenner, his voice registering surprise that there was an Earth-human female inside the bulky suit. “I assumed that, lacking information on its planet of origin, you might want to know if there were any safe atmospheric compositions in which it could be examined—I was assuming that, being a bird, it needed an atmosphere to fly in and that it had been dumped in space because of its diseased condition…”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Listening, Conway could not help admiring the smooth way in which Murchison was getting the Corps medic to tell them about the things he had done wrong. As an e-t pathologist she was used to non-specialists interfering and complicating her job, and it was necessary that she discover as much as possible about the being’s original condition before the changes or additional damage caused by inexpert examination—no matter how well-intentioned—had been introduced. She was finding out all that she needed to know quietly and without giving offense, as if she was Prilicla in human form.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("But as Brenner continued talking it became increasingly clear that he had made few, if any, mistakes, and a fair proportion of Conway’s professional admiration was being diverted towards the Lieutenant.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page29"
    }
  }, [_vm._v("“…After I sent the preliminary report and we were on our way,” Brenner was saying, “I discovered two small, rough areas on the black stuff covering the creature—a small, circular patch at the base of the neck, right here, and an oval patch, a little larger, which you can see on the underside. In both these areas the black stuff is ")]), _c('a', {
    attrs: {
      "id": "page30"
    }
  }, [_vm._v("cracked but with the cracks filled, or partly filled, by more of the stuff, and a few of the barnacles in these areas have been damaged as well. This is where I took my specimens.”")])]), _c('a', {
    attrs: {
      "id": "page30"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Marking the places you took them from, I see,” said Murchison. “Go on, Doctor.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Yes, ma’am,” said the Lieutenant, and went on. “The black material seems to be a near-perfect insulator—it is highly resistant to heat, including that of a cutting torch at medium power. At very high temperatures the area under test formed a black ash which flaked away but showed no sign of softening or cracking. The chips of shell from the damaged barnacles were not quite so heat-resistant unless they happened to be covered by the black material.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“The black stuff was also resistant to chemical attack,” Brenner continued, “but not the pieces of shell. When the chips were exposed to various basic atmospheric types, the results seemed to indicate that they had not originated on one of the exotic environments—methane- or ammonia- or even chlorine-based atmosphere envelopes. Composition of the fragments seems to be basic hydrocarbon material, and they did not react to short-term exposures to an oxygen-rich mixture—”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Give me the details of the tests you made,” said Murchison, suddenly becoming very businesslike and, although the Lieutenant did not know it, very complimentary. Conway signaled Prilicla to come closer, leaving the professional and amateur pathologists to get on with it.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I don’t think the patient is capable of movement,” he told the Cinrusskin. “I don’t even know if it’s alive. Is it?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Prilicla’s limbs trembled as it steeled itself to make a negative reply and by so doing, become just the slightest bit disagreeable. It said, “That is a deceptively simple question, friend Conway. All that I can say is that it doesn’t appear to be quite dead.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“But you can detect the emotional emanations from a sleeping or deeply unconscious mind,” said Conway incredulously. “Is there no emotional radiation at all?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page30"
    }
  }, [_vm._v("“There are traces, friend Conway,” said the Cinrusskin, still trembling, “but they are too faint to be identifiable. There is no self-awareness and the traces which are apparent do not, so far as I am able to tell, originate from the being’s cranial area—they seem to ")]), _c('a', {
    attrs: {
      "id": "page31"
    }
  }, [_vm._v("emanate from the body as a whole. I have never encountered this effect before, so I lack sufficient information or experience even to speculate.”")])]), _c('a', {
    attrs: {
      "id": "page31"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“But you will,” said Conway, smiling.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Of course,” said Prilicla. “It is possible that if the being was both deeply unconscious and at the same time was having the nerve endings in its skin constantly stimulated by severe pain, this might explain the effect which I can detect on and for some distance below the skin.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“But that means that you are detecting the peripheral nerve network and not the brain,” said Conway. “That is unusual.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Highly unusual, friend Conway,” said the little empath. “The brain in question would have to have had important nerve trunks severed or have suffered major structural damage.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("In short, Conway thought grimly, we may have been handed someone’s cast-off patient.")]), _vm._v(" "), _c('p', {
    staticClass: "chapterHeadA",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("II")])]), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("Murchison and Brenner, using the pathologist’s sterile drills, were taking deep samples as well as collecting and labelling chippings of shell and the black material which covered the patient—more accurately, Murchison took the samples while the Lieutenant sealed the tiny openings she made. Conway returned to the tender with Prilicla to arrange accommodation for the patient based on their sketchy knowledge—an evacuated chamber large enough to hold the thing, with provision for restraining it and for surrounding it with an oxygen-based atmosphere—and was followed shortly afterwards by the others.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("It was then that Brenner saw for the first time the contents of the pathologist’s spacesuit, and Prilicla began a slow tremble.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Unless covered by a heavy duty suit fitted with an opaque sun filter, Murchison displayed a combination of physiological features which made it impossible for any male Earth-human member of the staff to regard her with anything approaching clinical detachment. The Lieutenant finally managed to drag his eyes away from her and to notice Prilicla.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Is something wrong, Doctor?” he asked, looking concerned.")])]), _c('a', {
    attrs: {
      "id": "page32"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“To the contrary, friend Brenner,” said the empath, still trembling slowly. “This type of involuntary physical activity is my species’ reaction to the close proximity of an intense but pleasurable source of emotional radiation of the kind usually associated with the biological urge to mate…”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The Cinrusskin broke off and stopped trembling because the Surgeon-Lieutenant’s suddenly red face was clashing discordantly against his green uniform, and Prilicla was feeling his embarrassment.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Murchison smiled sympathetically and said, “Perhaps I am the cause, Lieutenant Brenner—I have intense feelings of pleasure over the way in which your earlier tests and deductions have saved me nearly four hours work in a very irksome spacesuit. Isn’t that so, Prilicla?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Most certainly,” said the empath, to whom lying was second nature so long as it made someone, especially itself, happy. “Empathy is not nearly as accurate as telepathy, you know, and mistakes of this kind frequently occur.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Conway cleared his throat and said, “I’ve arranged to see O’Mara just as soon as we have the patient accommodated which, initially, will be in an evacuated dock and storage chamber on Level 103. We will use the tender’s tractor beam to transfer the patient to the hospital, so if you are needed on board "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Torrance")]), _vm._v(", Lieutenant…?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Brenner shook his head. “The Captain would like to spend some time here, if possible, and so would I if I wouldn’t be in the way. It’s my first time to visit this place. Are there, ah, many other Earth-humans on the medical staff?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("If you mean like Murchison")]), _vm._v(", Conway thought smugly, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("the answer is no")]), _vm._v(". Aloud, he said, “We would welcome your help, of course. But you do not know what you are letting yourself in for, Lieutenant, and you keep asking about the Earth-humans on the staff. Are you xenophobic, even slightly? Uncomfortable near extraterrestrials?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Certainly not,” said Brenner firmly, then added, “Of course, I wouldn’t want to marry one.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page32"
    }
  }, [_vm._v("Prilicla began the slow shakes again. The musical trills and clicks of its Cinrusskin speech formed a pleasant background to its translated voice as it said, “From the sudden flood of pleasant emotional ")]), _c('a', {
    attrs: {
      "id": "page33"
    }
  }, [_vm._v("radiation, for which I can see no apparent reason in the current situation and recent dialogue, I assume that someone has made what Earth-humans call a joke.”")])]), _c('a', {
    attrs: {
      "id": "page33"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("At Level 103 Prilicla left to check on its wards while the others supervised the transfer of the great, stiff-winged bird into the storage chamber. Looking at the swept-back, partially folded wings and stiffly extended neck, Conway was reminded of one of the old-time space shuttles. His mind began to slip off on an interesting but ridiculous, tangent and he had to remind himself that birds did "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("not")]), _vm._v(" fly, in space.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("With the patient immobilized under one full G of artificial gravity it still took another three hours before Murchison had everything she wanted in the way of specimens and x-rays. In part the delay was caused by them having to work in pressure suits because, as Murchison put it, there would be little risk in observing the patient for a few more hours in airless conditions until they had worked out its atmosphere requirements with exactness—otherwise they might simply end by observing its processes of decomposition.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("But their information on the patient was growing with every minute that passed, and the results of their tests—transmitted direct from Pathology by the portable communicator beside them—were both interesting and utterly baffling. Conway lost all track of time until the communicator chimed for attention and the face of Major O’Mara glowered out at them.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Conway, you arranged to see me here seven and one half minutes ago,” said the Chief Psychologist. “No doubt you were just leaving.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I’m sorry, sir,” said Conway, “the preliminary investigation is taking longer than I estimated, and I want to have something concrete to report before seeing you.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("There was a faint rustling sound as O’Mara breathed heavily through his nose. The Chief Psychologist’s face was about as readable as a piece of weathered basalt, which in some respects it resembled, but the eyes which studied Conway opened into a mind so keenly analytical that it gave the Major what amounted to a telepathic faculty.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page33"
    }
  }, [_vm._v("As Chief Psychologist of a multi-environment hospital he was responsible for the mental well-being of a staff of several thousand ")]), _c('a', {
    attrs: {
      "id": "page34"
    }
  }, [_vm._v("entities belonging to more than sixty different species. Even though his Monitor Corps rank of Major did not place him high in the chain of command, there was no clear limit to his authority. To O’Mara the medical staff were patients, too, and part of his job was to assign the right kind of doctor—whether Earth-human or e-t—to a given patient.")])]), _c('a', {
    attrs: {
      "id": "page34"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Given even the highest qualities of tolerance and mutual respect, potentially dangerous situations could still arise through ignorance or misunderstanding, or a being could develop xenophobia to a degree which threatened to affect its professional competence, mental stability, or both. An Earth-human doctor, for instance, who had a subconscious fear of spiders would not be able to bring to bear on a Cinrusskin patient the proper degree of clinical detachment necessary for its treatment. And if someone like Prilicla were to treat such an Earth-human patient…")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("A large part of O’Mara’s job was to detect and eradicate such trouble among the medical staff while other members of his department saw to it that the problem did not arise where the patients were concerned. According to O’Mara himself, however, the true reason for the high degree of mental stability among the variegated and often touchy medical staff was that they were all too frightened of him to risk going mad.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Caustically, he said, “Doctor Conway, I freely admit that this patient is unusual even by your standards, but you must have discovered a few simple facts about it and its condition. Is it alive? Is it diseased or injured? Does it possess intelligence? Are you wasting your time on an outsize, space-frozen turkey?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page34"
    }
  }, [_vm._v("Conway ignored the rhetoric and tried to answer the questions. He said. “The patient is alive, just barely, and the indications are that it is both diseased—the exact nature of the disease is not yet known—and suffering from gross physical injury, specifically a punctured wound made by a large, high-velocity projectile or a tightly focused heat beam which passed through the base of the neck and the upper chestal area. The wound entrance and exit is sealed by the black covering or growth—we still don’t know which—encasing the body. Regarding the possibility of intelligence, the cranial capacity is large enough not to rule this out, but again, the head is too deeply unconscious to radiate detectable emotion. The manip")]), _c('a', {
    attrs: {
      "id": "page35"
    }
  }, [_vm._v("ulatory appendages, whose degree of specialization or otherwise can give a strong indication of the presence or absence of intelligence, have been removed.")])]), _c('a', {
    attrs: {
      "id": "page35"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Not by us,” Conway added.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("O’Mara was silent for a moment, then he said, “I see. Another one of your deceptively simple cases. No doubt you will have deceptively simple special requirements. Accommodation? Physiology tapes? Information on planet of origin?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Conway shook his head. “I don’t believe that you have a physiology tape that will cover this patient’s type—all the winged species we know are light-gravity beings, and this one has muscles for about four Gs. The present accommodation is fine, although we’ll have to be careful in case of contamination of or from the chlorine level above us—the seals to storage compartments like this are not designed for constant traffic, unlike the ward airlocks—”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I didn’t know that, of course.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Sorry, sir,” said Conway. “I was thinking aloud, and partly for the benefit of Surgeon-Lieutenant Brenner, who is visiting this madhouse for the first time. Regarding information on its planet of origin, I would like you to approach Colonel Skempton to ask him if it would be possible for "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Torrance")]), _vm._v(" to return to that area to investigate the two nearer star systems, to look for beings with a similar physiological classification.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“In other words,” said O’Mara dryly, “you have a difficult medical problem and think that the best solution is to find the patient’s own doctor.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Conway smiled and said, “We don’t need full cultural contact—just a quick look, atmosphere samples and specimens of local plant and animal life, if "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Torrance")]), _vm._v(" wouldn’t mind soft-landing a probe—”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("O’Mara broke the connection at that point with a sound which was untranslatable and Conway, now that they had gone as far as they could with the patient without the path reports, suddenly realized how hungry he was.")]), _vm._v(" "), _c('p', {
    staticClass: "chapterHeadA",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("III")])])]), _c('p', {
    staticClass: "paraNoIndent",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page35"
    }
  }, [_vm._v("To reach the dining hall reserved for warm-bodied oxygen breathers they had to travel through two levels, none of which required protective suits, and a network of corridors crowded with entities which ")]), _c('a', {
    attrs: {
      "id": "page36"
    }
  }, [_vm._v("flapped, crawled, undulated and occasionally walked past them. They were met at the entrance by Prilicla who was carrying a folder of green path reports.")])]), _c('a', {
    attrs: {
      "id": "page36"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("As they entered the last Earth-human table was being taken by a bunch of crab-like Melfans and a Tralthan—Melfans could adapt themselves to the low stools and the Tralthans did everything including sleep on their six elephantine feet. Prilicla spotted an empty table in the Kelgian area and flew across to claim it before the party of Corps maintenancemen could get there. Luckily it was beyond the range of their emotional radiation.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Conway began eagerly leafing through the reports once he saw that the Lieutenant was being shown by Murchison how to balance on the edge of a Kelgian chair within reach of the food he had ordered. But for once Brenner’s attention was not on the shapely pathologist. He was staring at Prilicla, his eyebrows almost lost in his hairline.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Cinrusskins prefer to eat while hovering—they say it aids the digestion,” explained Murchison, and added, “The slipstream helps cool the soup, too.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Prilicla maintained a stable hover while they concentrated on refuelling, breaking off only to pass around the reports. Finally Conway, feeling pleasantly distended, turned to the Cinrusskin.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I don’t know how you managed it,” he said warmly. “When "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("I")]), _vm._v(" want a fast report from Thornnastor the most he will let me do is just two places in the queue.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Prilicla trembled at the compliment as it replied “I insisted, quite truthfully, that our patient was at the point of death.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“But not,” said Murchison dryly, “that it has been in that condition for a very long time.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You’re sure of that?” asked Conway.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I am now,” she answered seriously, tapping one of the reports as she spoke. “The indications are that the large punctured wound was inflicted by a meteorite collision some time after the disease, that is the barnacles and coating material were in position. The coating which flowed into and across the wound, effectively sealed it.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page36"
    }
  }, [_vm._v("“As well,” she continued, “these tests show that a very complex chemical form of suspended animation—not just hypothermia—")]), _c('a', {
    attrs: {
      "id": "page37"
    }
  }, [_vm._v("was used and that it was applied organ by organ, almost cell by cell, by micro-injections of the required specifics. In a way you could think of it as if the creature had been embalmed before it was quite dead in an effort to prolong its life.”")])]), _c('a', {
    attrs: {
      "id": "page37"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“What about the missing legs or claws?” said Conway, “"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("and")]), _vm._v(" the evidence of charring under the coating in the areas behind the wings? And the pieces of what seems to be a different kind of barnacle in those areas?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“It is possible,” Murchison replied, “that the disease initially affected the being’s legs or claws, perhaps during its equivalent of nesting. The removal of the limbs and the evidence of charring you mention might have been early and unsuccessful attempts at curing the patient’s condition. Remember that virtually all of the creature’s body wastes were eliminated before the coating was applied. That is standard procedure before hibernation, anesthesia or major surgery.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The silence which followed was broken by the Lieutenant, who said, “Excuse me, I’m getting lost. This disease or growth, what exactly do we know about it?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("They knew that the outward symptoms of the disease were the barnacle-like growths, Murchison told him, which covered the patient’s tegument so completely that it could have been a suit of chain mail. It was still open to argument whether the barnacles were skin conditions which had sprouted rootlets or a subcutaneous condition with a barnacle-like eruption on the surface, but in either event they were held by a thick pencil of fine rootlets extending and subdividing to an unknown depth within the patient. They penetrated not only the subcutaneous tissue and underlying musculature, but practically all of the vital organs and central nervous systems. And the rootlets were hungry. There could be no doubt from the condition of the tissue underlying the barnacles that this was a severely wasting disease which was far advanced.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“It seems to me that you should have been called in earlier,” said Brenner, “and that the patient was sealed up just before it was due to die.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page37"
    }
  }, [_vm._v("Conway nodded and said, “But it isn’t hopeless. Some of our e-ts practice micro-surgery techniques which would enable them to excise the rootlets, even the ones which are tangled up in the nerve ")]), _c('a', {
    attrs: {
      "id": "page38"
    }
  }, [_vm._v("bundles. It is a very slow procedure, however, and there is the danger that when we revive the patient the disease will also be revived and that it might progress faster than the micro-surgeon. I think the answer is to learn as much as we possibly can about the disease before we do anything else.”")])]), _c('a', {
    attrs: {
      "id": "page38"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("When they returned to the patient there was a message waiting from O’Mara to say that "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Torrance")]), _vm._v(" had left with the promise of preliminary reports on the two solar systems nearest to the find within three days. During those three days Conway expected to devise procedures which would remove the coating and barnacles from the patient, arrest the disease and initiate curative surgery so that the scoutship’s reports would be needed only to prepare proper accommodation for the patient’s convalescence.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("During those three days, however, they got precisely nowhere.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The material which encased barnacles and patient alike could be drilled and chipped away with great difficulty and an enormous waste of time—the process resembled that of chipping out a fossil without inflicting damage, and this particular fossil was fifty feet long and over eighty from tip to tip of its partially folded wings. When Conway insisted that Pathology produce a faster method of stripping the patient he was told that the coating was a complex organic, that the specifics they had devised for dissolving it would produce large quantities of toxic gases—toxic to the patient as well as the attending physicians—and that the shell material of the barnacles would be instantly dissolved by this solvent and that it would not be good for the patient’s skin and underlying tissue, either. They went back to drilling and chipping.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Murchison, who was continually withdrawing micro-specimens from the areas affected by the rootlets, was informative but unhelpful.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I’m not suggesting that you should abandon this one,” she said sympathetically, “but you should start thinking about it. In addition to the widespread tissue wastage, there is evidence of structural damage to the wing muscles—damage which may well have been self-inflicted—and I think the heart has ruptured. This will mean major surgical repairs as well as—”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page38"
    }
  }, [_vm._v("“This muscle and heart damage,” said Conway sharply. “Could ")]), _c('a', {
    attrs: {
      "id": "page39"
    }
  }, [_vm._v("it have been caused by the patient trying to get out of its casing?”")])]), _c('a', {
    attrs: {
      "id": "page39"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“It is possible but not likely,” she replied in a voice which reminded him that he was not talking to a junior intern and that past and present relationships could change with very little notice. “That coating is hard, but it is relatively very thin and the leverage of the patient’s wings is considerable. I would say that the heart and muscle damage occurred before the patient was encased.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I’m sorry if…” began Conway.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“There is also the fact,” she went on coldly, “that the barnacles are clustered thickly about the patient’s head and along the spine. Even with our tissue and nerve regeneration techniques, the patient may never be able to think or move itself even if we are successful in returning it to a technically living state.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I hadn’t realized,” said Conway dully, “that it was as serious as that. But there must be something we can do…” He tried to pull his face muscles into a smile. “…if only to preserve Brenner’s illusions about the miracle-workers of Sector General.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Brenner had been looking from one to the other, obviously wondering whether this was a spirited professional discussion or the beginning of some kind of family fight. But the Lieutenant was tactful as well as observant. He said, “I would have given up a long time ago.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Before either of them could reply the communicator chimed and Chief of Pathology Thornnastor was framed in the screen.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“My department,” said the Tralthan, “has worked long and diligently to discover a method of removing the coating material by chemical means, but in vain. The material is, however, affected by intense heat. At high temperatures the surface crumbles, the ashy deposit can be scraped or blown away and heat again applied. The process can be continued safely until the coating is very thin, after which it could be removed in large sections without harm to the patient.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page39"
    }
  }, [_vm._v("Conway obtained the temperature and thickness figures, thanked Thornnastor and then used the communicator to call the maintenance section for cutting torches and operators. He had not forgotten Murchison’s doubts regarding the advisability of attempting a cure, but he had to go on trying. He did not "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("know")]), _vm._v(" that the ")]), _c('a', {
    attrs: {
      "id": "page40"
    }
  }, [_vm._v("great, diseased bird would end as a winged vegetable, and he would not know until they knew everything possible about the disease which was affecting it.")])]), _c('a', {
    attrs: {
      "id": "page40"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Because the heat treatment was untried they began near the tail, where the vital organs were deeply buried and where the area had already been disturbed, presumably by the efforts of their medical predecessors.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("After only half an hour’s continuous burning they had their first stroke of luck in three days. They discovered a barnacle which was embedded upside down in the patient—its bundle of rootlets fanned out to link up with the other barnacles, but a few of them curved down and past the rim of its shell to enter the patient. The surface rootlet network was clearly visible as the flame of the torch burned the rootlet material into a fine, incandescent web. One of the briefly incandescent rootlets pointed towards a barnacle which was larger and differently shaped.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Patiently they painted both objects and their immediate surroundings with the cutting torches, brushing away the crumbling layers of coating until it was wafer thin. They cracked it, carefully peeled back the remains of the coating and lifted away two perfect specimens.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“They are dead,” asked Conway, “not just dormant?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“They are dead,” said Prilicla.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“And the patient?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Life is still present, friend Conway, but the radiation is extremely weak, and diffuse.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Conway studied the area bared by the removal of the two specimens. Beneath the first was a small, deep hollow which followed the contours of the reversed shell. The underlying tissues showed a high degree of compression, and the few rootlets in evidence were much too weak and fine to have held the barnacle so tightly against the patient. Something or somebody had pressed the barnacle into position with considerable force.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The second, and different, specimen had been held only by the coating, apparently—it did not possess rootlets. But it did possess wings folded into long slits in its carapace and so, on closer inspection, did the first type.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page40"
    }
  }, [_vm._v("Prilicla alighted beside them, trembling slightly and erratically ")]), _c('a', {
    attrs: {
      "id": "page41"
    }
  }, [_vm._v("in the fashion which denoted excitement. It said, “You will have noticed that these are two entirely different species, friend Conway. Both are large, winged insects of the type which require a low-gravity planet with a thick air envelope—not unlike Cinruss. It is possible that the first type is a predator parasite and that the second is a natural enemy, introduced by a third party in an attempt to cure the patient.”")])]), _c('a', {
    attrs: {
      "id": "page41"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Conway nodded. “It would explain why type one turned on to its back when approached by type two…”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I hope,” said Murchison apologetically, “that your theory is flexible enough to accept another datum.” She had been scraping persistently at a piece of coating which was still adhering to a smaller slit in the barnacle. “The coating material was not applied by a third party, it is a body secretion of type one.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“If you don’t mind,” she added, “I’ll take both of these beasties to Pathology for a long, close look.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("For several minutes after she left nobody spoke. Prilicla began to tremble again and, judging by the expression of Brenner’s face, it was at something the officer was feeling. It was the Lieutenant who broke the silence.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“If the parasites are responsible for the coating,” he said sickly, “then there was no earlier attempt to cure the patient. Our heavy-gravity patient was probably attacked on the light-gravity planet of the flying barnacles, they sank in their rootlets or tendrils, paralyzed its muscles and nervous system and encased it in a…a shell of slowly feeding maggots when it wasn’t even dead—”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“A little more clinical detachment, Lieutenant,” said Conway sharply. “You’re bothering Prilicla. And while something like that may have happened, there are still a few awkward facts which don’t fit. That depression under the inverted barnacle still bothers me.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Maybe it sat on one of them,” said Brenner angrily, his feeling of revulsion temporarily overcoming his manners. “And I can understand why its friends dumped the patient into space—there was nothing else they could do.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He hesitated, then said, “I’m sorry, Doctor. But is there anything else that you can do?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“There is something,” said Conway grimly, “that we can "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("try…")]), _vm._v("”")])]), _c('a', {
    attrs: {
      "id": "page42"
    }
  }, [_c('p', {
    staticClass: "chapterHeadA",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("IV")])]), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("According to Prilicla their patient was, just barely, alive, and now that the barnacles were known to be the attacking organisms and not just surface eruptions, they and their coating must be removed as quickly as possible. Removal of the tendrils would require more delicate and time-consuming work, but the surface condition would respond to heat and, with the barnacles removed, the patient just might recover enough to be able to help Conway to help it. Pathology had already suggested methods for restarting its paralyzed life processes.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He would need at least fifty cutting torches operating simultaneously with high-pressure air hoses to blow the ash away. They would begin burning on the head, neck, breast and wing-muscle areas, freeing the patient of barnacle control of the brain, lungs and heart. If the heart was in a terminal condition emergency surgery would be necessary to bypass it—Murchison had already mapped out the arterial and venous processes in the area. And in case the patient twitched or began flapping its wings, they would need the protection of heavy-duty suits.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("But no—Prilicla, who would be monitoring the emotional radiation during the op, would need maximum protection. The others would have to dodge until it could be immobilized with pressors. If emergency surgery was necessary, heavy-duty suits were too cumbersome anyway. As well, the communicator would have to be moved to a side compartment in case it was damaged, because the adjoining levels would have to be alerted and various specialist staff would have to be standing by.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("While he gave the necessary orders Conway moved briskly but unhurriedly and his tone was quiet and confident. But all the time he had a vague but persistent feeling that he was saying and doing and, most of all, thinking all the wrong things.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("O’Mara did not approve of his proposed line of treatment but, apart from asking whether Conway intended curing or barbecuing the patient, he did not interfere. He added that there was still no report from "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Torrance")]), _vm._v(".")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page42"
    }
  }, [_vm._v("Finally they were ready to go. The maintenance technicians with cutting torches and air lines hissing—but directed away from the ")]), _c('a', {
    attrs: {
      "id": "page43"
    }
  }, [_vm._v("patient—were positioned around the head, neck and leading edges of the wings. Behind them waited the specialist and medical technicians with stimulants, a general purpose heart-lung machine and the bright, sterile tools of their trade. The doors to the side compartments were dogged open in case the patient revived too suddenly and they had to take cover. There was no logical reason for waiting any longer.")])]), _c('a', {
    attrs: {
      "id": "page43"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Conway gave the signal to begin only seconds before his communicator chimed and Murchison, looking disheveled and very cross, filled the screen.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“There has been a slight accident, an explosion,” she said. “Our type two flew across the lab, damaged some test equipment and scared hell out of—”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“But it was dead,” protested Conway. “They were both dead—Prilicla said so.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“It still is,” said Murchison, “and it didn’t fly exactly—it shot away from us. I’m not yet sure of the mechanics of the process, but apparently the thing produces gases in its intestinal tract which react explosively together, propelling it forward. Used in conjunction with its wings this would help it to escape fast-moving natural enemies like the barnacle. The gases must still have been present when I began work.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“There is a similar species, much smaller,” she went on, “which is native to Earth. We studied the more exotic types of Earth fauna in preparation for the e-t courses. It was called a bombardier beetle and it—”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("“Doctor Conway!”")])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He swung away from the screen and ran into the main compartment. He did not need to be an empath to know that something was seriously wrong.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The team leader of the maintenancemen was waving frantically and Prilicla, encased in its protective globe and supported by gravity nullifiers, was drifting above the man’s head and trembling.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Increasing awareness, friend Conway,” reported the empath. “Suggesting rapidly returning consciousness. Feelings of fear and confusion.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Some of the confusion")]), _vm._v(", thought Conway, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("belongs to me…")])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The maintenanceman simply pointed.")])]), _c('a', {
    attrs: {
      "id": "page44"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Instead of the hard coating he had expected to see there was a black, oily, semi-liquid which flowed and rippled and dripped slowly on to the floor plating. As he watched the area where the flame was being applied, the stuff rolled away from one of the barnacles, which twitched and unfolded its wings. The wings flapped, slowly at first, and it began pulling free of the patient, drawing its long tendrils out of the bird until it was completely detached and it went blundering into the air.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Kill the torches,” said Conway urgently, “but cool it with the air hose. Try to harden that black stuff.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("But the thick, black liquid would not harden. Once initiated by the heat the softening process was self-sustaining. The patient’s neck, no longer supported by solid material, slumped heavily on to the deck followed a few seconds later by the massive wings. The black pool around the patient widened and more and more of the barnacles struggled free to blunder about the compartment on wide, membranous wings, trailing their tendrils behind them like long, fine plumes.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Back everybody! Take cover, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("quickly!")]), _vm._v("”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Their patient lay motionless and almost certainly dead, but there was nothing that Conway could do. Neither the maintenancemen nor the medical technicians were protected against those fine, harmless-looking tendrils of the barnacles—only Prilicla in its transparent globe was safe there, and now there seemed to be hundreds of the things filling the air. He knew that he should feel badly about the patient, but somehow he did not. Was it simply delayed reaction or was there another reason?")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Friend Conway,” said Prilicla, bumping him gently with its globe, “I suggest that you take your own advice.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The thought of fine, barnacle tendrils probing through his clothing, skin and underlying tissues, paralyzing his muscles and scrambling his brain made him run for the side compartment, closely followed by Brenner and Prilicla. The Lieutenant closed the door as soon as the Cinrusskin was inside.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("There was a barnacle already there.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page44"
    }
  }, [_vm._v("For a split second Conway’s mind was like a camera, registering everything as it was in the small room: the face of O’Mara on the communicator screen, as expressionless as a slab of rock with only ")]), _c('a', {
    attrs: {
      "id": "page45"
    }
  }, [_vm._v("the eyes showing his concern; Prilicla trembling within its protective globe; the barnacle hovering near the ceiling, its tendrils blowing in a self-generated breeze, and Brenner with one eye closed in a diabolical wink as he pointed his gun—a type which threw explosive pellets—at the hovering barnacle.")])]), _c('a', {
    attrs: {
      "id": "page45"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("There was something wrong.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Don’t shoot,” said Conway, quietly but firmly, then asked, “Are you afraid, Lieutenant?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I don’t normally use this thing,” said Brenner, looking puzzled, “but I can. No, I’m not afraid.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“And I’m not afraid because you have that gun,” said Conway. “Prilicla is protected and has nothing to fear. So who…” He indicated the empath’s trembling feelers. “"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("…is")]), _vm._v(" afraid?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“It is, friend Conway,” said Prilicla, indicating the barnacle. “It is afraid and confused and intensely curious.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Conway nodded. He could see Prilicla beginning to react to his intense relief. He said, “Nudge it outside, Prilicla, when the Lieutenant opens the door—just in case of accidents. But gently.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("As soon as it was outside, O’Mara’s voice roared from the communicator.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“What the blazes have you done?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Conway tried to find a simple answer to an apparently simple question. He said, “I suppose you could say that I have prematurely initiated a planetary re-entry sequence…”")]), _vm._v(" "), _c('p', {
    staticClass: "paraCenter1",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "Images/ast.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("The report from "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Torrance")]), _vm._v(" arrived just before Conway reached O’Mara’s office. It said that one of the two stars had a light-gravity planet which was inhabitable while showing no indications of advanced technology, and that the other possessed a large, fast-spinning world which was so flattened at the poles that it resembled two soup bowls joined at the rims. On the latter world the atmosphere was dense and far-reaching, gravity varied between three Gs at the poles to one-quarter G at the equator, and surface metals were nonexistent. Very recently, in astronomical terms, the world had spiraled too close to its sun and planet-wide volcanic activity and steam had rendered the atmosphere opaque. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Torrance")]), _vm._v(" doubted that it was still habitable.")])]), _c('a', {
    attrs: {
      "id": "page46"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“That supports my theory,” said Conway excitedly when O’Mara had relayed the report to him, “that the bird and the barnacles, and the other insect life-form, originate from the same planet. The barnacles are parasites, of course, with a small individual brain capacity, but intelligent when linked and operating as a gestalt. They must have known that their planet was heading for destruction for centuries, and decided to escape. But just think of what it must have taken to develop a space-travel capability completely without metal…”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Somehow they had learned how to trap the giant birds from the heavy-gravity polar regions and to control them with their tendrils—the barnacles were a physically weak species and their ability to control non-intelligent hosts was the only strength they had. The birds, Conway now knew, were a non-intelligent species as were the tendril-less beetles. They had taken control of the birds and had flown them high above the equator, commanding maximum physical effort to achieve the required height and velocity for the linkup with the final propulsion stage—the beetles. They also had been controlled by the barnacles, perhaps fifty to each parasite, and they had attached themselves to the areas behind the wings in a gigantic, narrow cone.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Meanwhile the bird had been shaped and paralyzed into the configuration of a supersonic glider, its claws removed to render it aerodynamically clean, and injected with the secretions which would arrest the processes of decomposition. The crew had then sealed it and themselves in position and gone into hibernation for the duration of the voyage using the bird’s tissue for life-support.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Once in position the propulsion cone comprising millions of insects, hundreds of thousands of which were the intelligent controllers, had begun firing. They had done so very evenly and gently, so as not to shatter or crush the narrow apex of the cone where it was attached to the bird. The beetles could be made to deliver their tiny modicum of thrust whether they were alive or dead and, even with their ability to seal themselves inside a hard coating, the propulsion controllers had not lived for very long—they also were expendable. But in dying they had helped an organic starship carrying a few hundred of their fellows to achieve escape velocity from their doomed planet and its sun.")])]), _c('a', {
    attrs: {
      "id": "page47"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“…I don’t know how they intended to position the bird for re-entry,” Conway went on admiringly, “but atmospheric heating was intended to trigger the organic melting process when they had braked sufficiently, allowing the barnacles to pull free of the bird and fly to the surface under their own wing-power. In my hurry to get rid of the coating I applied heat over a wide area of the forward section, which simulated re-entry conditions and—”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Yes, yes,” said O’Mara testily. “A masterly exercise in medical deduction and sheer blasted luck! And now, I suppose, you will leave me to clean up after you by devising a method for communicating with these beasties and arranging for their transport to their intended destination. Or was there something else you wanted?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Conway nodded. “Brenner tells me that his scoutship flotilla, using an extension of the search procedure for overdue ships, could cover the volume of space between the home and destination stars. There are probably other birds, perhaps hundreds of them—”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("O’Mara opened his mouth and looked ready to emulate a bombardier beetle. Conway added hastily, “I don’t want them brought here, sir. The Corps can take them where they are going, melt them on the surface to avoid re-entry casualties, and explain the situation to them.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“They’re colonists, after all—not patients.”")])])]), _c('a', {
    attrs: {
      "id": "page47"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page47"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-593f3db8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9780312877705_ch01.vue
// module id = 78
// module chunks = 0